import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import FeatherIcon from "feather-icons-react"

const TestimonialsSection = () => {
    const { t } = useTranslation()

    // Testimonials with sector descriptions only (no specific company names)
    const testimonials = [
        {
            name: "A. Y.",
            position: "İnsan Kaynakları Müdürü",
            sector: "Kamu Sektörü",
            text: "Netta platformu ile personel süreçlerimizi tamamen dijitalleştirdik. İzin takibi ve performans yönetimi artık çok kolay.",
            rating: 5
        },
        {
            name: "F. K.",
            position: "Operasyon Direktörü",
            sector: "Tekstil Sektörü",
            text: "Proje yönetimi ve iş akışı modülleri sayesinde üretim verimliliğimiz %35 arttı. Ekip koordinasyonu mükemmel.",
            rating: 5
        },
        {
            name: "M. Ö.",
            position: "Bilgi İşlem Müdürü",
            sector: "Finans Sektörü",
            text: "KVKK uyumluluğu ve on-premise kurulum seçeneği tercihimizde belirleyici oldu. Veri güvenliğinden eminiz.",
            rating: 5
        }
    ]

    return (
        <section className="section bg-light">
            <Container>
                {/* Section Title */}
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">{t("testimonials.title")}</h4>
                            <p className="text-muted para-desc mx-auto mb-0">
                                {t("testimonials.subtitle")}
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Testimonials Grid */}
                <Row>
                    {testimonials.map((testimonial, key) => (
                        <Col lg={4} md={6} className="mt-4 pt-2" key={key}>
                            <Card className="customer-testi border-0 shadow rounded h-100">
                                <CardBody className="p-4">
                                    {/* Stars */}
                                    <div className="mb-3">
                                        {[...Array(testimonial.rating)].map((_, i) => (
                                            <FeatherIcon
                                                key={i}
                                                icon="star"
                                                className="text-warning"
                                                fill="#f17425"
                                                style={{ width: "16px", height: "16px" }}
                                            />
                                        ))}
                                    </div>
                                    <p className="text-muted mb-4">" {testimonial.text} "</p>
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="rounded-circle bg-primary d-flex align-items-center justify-content-center"
                                            style={{ width: "50px", height: "50px" }}
                                        >
                                            <span className="text-white fw-bold">
                                                {testimonial.name.charAt(0)}
                                            </span>
                                        </div>
                                        <div className="ms-3">
                                            <h6 className="mb-0">{testimonial.name}</h6>
                                            <small className="text-muted">
                                                {testimonial.position} • {testimonial.sector}
                                            </small>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default TestimonialsSection
